import { useState, useEffect } from 'react';
import { Tabs, Space } from 'antd';
import Table from '../../../../TableResizable';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import { UserOutlined, ContactsOutlined } from '@ant-design/icons';
import axios from 'axios';
import Tab1 from './Tab1';
import Utilisateur from '../../../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../../../Services/Auth/sessionAuth';
import Data from '../../../../../Data/Data.json';
import SweetAlert from 'sweetalert2';
import { Crypter } from '../../../../../Functions/Security/Crypter';
import { Box, Typography } from '@mui/material';
import { ColumnsType } from 'antd/es/table';
import formatDate from '../../../../../Functions/Traitement/fomatDate';
import ReformatDate from '../../../../../Functions/Traitement/ReformatDate';
import Tab3 from './Tab3';
import ParamsPicklist from '../../../../../Types/ParamsPicklist';
import Datas from '../../../../../Data/Data.json';
import formatNumber from '../../../../../Functions/Traitement/FormatNumber';
import { DemandeIjaraDto } from '../../../../../Models/DemandeIjarahDto';
import DataTypeTable from '../../../../../Types/DataTypeTable';
import Tab2 from './Tab2';
import Tab4 from './Tab4';
import Tab5 from './Tab5';

const ValidationDocumentIjarah = () => {
  const auth = useAuthUser();
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()));
  const authHeader = useAuthHeader();

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [, forceUpdate] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [pageLoad, setPageLoad] = useState(true);
  const [data, setData] = useState<DemandeIjaraDto[]>([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [garantiesTableau, setGarantiesTableau] = useState<DataTypeTable[]>([]);
  const [datatabamort, setdatatabamort] = useState([]);
  const [document, setDocument] = useState([]);
  const [demandeChargee, setDemandeChargee] = useState(false);

  const loadFinancement = () => {
    localStorage.clear();
    setPageLoad(false);
    setLoading(true);
    setData([]);

    let searchClientComptes: ParamsPicklist = {
      CodeAgence: user.codage,
      Table: 'DEMAND_FINIJARA',
      Colonne1: 'EtapeActuelle',
      Colonne2: '',
      Init: 'VALIDATION_DOCUMENTAIRE',
      Colagence: 'CODAGE',
      Choix: 34,
    };

    var config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Datas.ApiUrl.AnySearch,
      headers: {
        'Content-Type': 'application/json',
        Authorization: authHeader(),
        CypherSearch: Crypter.encrypt(JSON.stringify(searchClientComptes)),
      },
    };
    axios
      .request(config)
      .then((response) => {
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data)).Value;
          if (res.StatutCode == 200) {
            let datas = res.Result.Table;
            if (datas.length === 0) {
              SweetAlert.fire({
                title: 'Aucune demande Ijara en attente de validation documentaire',
                icon: 'warning',
              });
            } else {
              var newData: DemandeIjaraDto[] = [];
              datas.map((data: any, indice: number) => {
                newData.push({
                  ...data,
                  key: indice,
                  NumeroDemande: data.NumeroDemande,
                  CODAGE: data.CODAGE,
                  Numcli: data.NUMCLI,
                  NOMCLI: data.NOMCLI,
                  DateDemande: data.DateDemande
                    ? new Date(data.DateDemande.substring(0, 10)).toLocaleDateString('fr')
                    : '',
                  CodeIjara: data.CodeIjara,
                  MontantDemande: data.MontantDemande,
                  CODGEA: data.CODGEA,
                  CoutAchatPropose: formatNumber(data.CoutAchatPropose),
                });
              });
              setData(newData);
            }
          }
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        SweetAlert.fire({ title: 'Error', text: error, icon: 'error' });
      });
  };

  if (pageLoad) {
    loadFinancement();
  }

  const columns: ColumnsType<any> = [
    { title: 'Date Demande', dataIndex: 'DateDemande' },
    { title: 'Agence', dataIndex: 'CODAGE' },
    { title: 'N° Demande', dataIndex: 'NumeroDemande' },
    { title: 'N° Client', dataIndex: 'Numcli' },
    { title: 'Nom Client', dataIndex: 'NOMCLI' },
    { title: 'Type de Ijara', dataIndex: 'CodeIjara' },
    { title: 'Code Gestionnaire', dataIndex: 'CODGEA' },
    { title: 'Coût Achat Proposé', dataIndex: 'CoutAcquisitionPropose' },
  ];

  useEffect(() => {
    forceUpdate({});
  }, []);

  function handleAnnulle() {
    form.resetFields();
    localStorage.clear();
    setGarantiesTableau([]);
    setdatatabamort([]);
    setDocument([]);
    setDemandeChargee(false);
    setSelectedRowKeys([]);
  }

  const consultTypeIjarah = () => {
    if (form.getFieldValue('CodeIjara') == null) {
      SweetAlert.fire({ title: 'Svp renseigner le Code du type de Ijara ', icon: 'warning' });
    } else {
      let data = Crypter.encrypt(form.getFieldValue('CodeIjara'));
      if (data.length != 0) {
        setLoading(true);
        let config = {
          method: 'get',
          maxBodyLength: Infinity,
          url: Data.ApiUrl.ReadParamsIjarah,
          headers: {
            CypherCodeIjara: data,
            Authorization: authHeader(),
            'Content-Type': 'application/json',
          },
        };
        axios
          .request(config)
          .then((response) => {
            setLoading(false);
            if (response.data) {
              const res = JSON.parse(Crypter.decrypt(response.data)).Value;
              if (res.StatutCode == 200) {
                const frais = res.Result.Table1[0]?.MontantFrais || 0;
                form.setFieldValue('CodeFrais', res.Result.Table4?.map((x: any) => x.CODOPE) || []);
                form.setFieldValue('MontantFrais', frais);
              } else {
                SweetAlert.fire({ title: res.Message, text: res.Result, icon: 'warning' });
              }
            }
          })
          .catch((error) => {
            setLoading(false);
            console.log(error);
            SweetAlert.fire({ title: 'Error', text: error, icon: 'error' });
          });
      }
    }
  };

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: (<span id='Tab'><UserOutlined /> Proposition</span>),
      children: <Tab1 form={form} consultTypeIjarah={consultTypeIjarah} />,
    },
    {
      key: '2',
      label: (<span id='Tab'><UserOutlined /> Documents</span>),
      children: <Tab5 form={form} document={document} />,
    },
    {
      key: '3',
      label: (<span id='Tab'><ContactsOutlined /> Garanties</span>),
      children: <Tab2 form={form} garantiesTableau={garantiesTableau} />,
    },
    {
      key: '4',
      label: (<span id='Tab'><ContactsOutlined /> Frais de Gestion</span>),
      children: <Tab3 form={form} />,
    },
    {
      key: '5',
      label: (<span id='Tab'> Tableau</span>),
      children: <Tab4 form={form} data={datatabamort} />,
    },
  ];

  function handleDemandeIjarah() {
    const numeroDemande = form.getFieldValue('NumeroDemande');
    if (!numeroDemande) {
      SweetAlert.fire({ title: 'Veuillez sélectionner une demande', icon: 'warning' });
      return;
    }

    let data = Crypter.encrypt(numeroDemande);
    let dataction = Crypter.encrypt('READ_DEMANDE');

    setLoading(true);
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Data.ApiUrl.ReadFinancementIjarah,
      headers: {
        CypherNumeroDemandeIjara: data,
        CypherAction: dataction,
        Authorization: authHeader(),
        'Content-Type': 'application/json',
      },
    };
    axios
      .request(config)
      .then((response) => {
        setLoading(false);
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data)).Value;
          console.log(res);
          if (res.StatutCode == 200) {
            form.setFieldsValue(res.Result.Table1[0]);
            form.setFieldValue('DatePremEch', ReformatDate(res.Result.Table1[0].DatePremEch));
            form.setFieldValue('lib_NUMCLI', res.Result.Table1[0].NOMCLI);
            form.setFieldValue('MontantDemande', res.Result.Table1[0].CoutAcquisitionDemande);
            form.setFieldValue('CoutAchatValide', res.Result.Table1[0].CoutAchatPropose);
            form.setFieldValue('MargeLocativeVal', res.Result.Table1[0].MargeLocativeProp);

            const garantiesRetournees: DataTypeTable[] = [];
            var newData: any = [];
            if (res.Result.Table2) {
              let montantGarantieCouvert = 0;
              res.Result.Table2.map((data: any) => {
                montantGarantieCouvert += data.MontantCouvert;
                garantiesRetournees.push({
                  ...data,
                  valCouvert: data.MontantCouvert,
                });
              });
              form.setFieldValue('montantGarantieCouvert', montantGarantieCouvert);
            }

            if (res.Result.Table3) {
              res.Result.Table3.map((data: any) => {
                newData.push({
                  ...data,
                  CapitalRembourse: formatNumber(data.CapitalRembourse),
                  CapitalRestant: formatNumber(data.CapitalRestant),
                  DateEcheance: data.DateEcheance
                    ? new Date(data.DateEcheance.substring(0, 10)).toLocaleDateString('fr')
                    : '',
                });
              });
              setdatatabamort(newData);
            }

            let documents = [];
            if (res.Result.Table4) {
              documents = res.Result.Table4.map((doc: any) => ({
                ...doc,
                key: doc.TypeCodeDoc || doc.IdDocument,
              }));
            }
            setDocument(documents);
            setGarantiesTableau(garantiesRetournees);
            setdatatabamort(newData as any);
            consultTypeIjarah();

            setDemandeChargee(true);
          } else {
            localStorage.removeItem(Data.LocalVariable.reset);
            SweetAlert.fire({ title: res.Message, icon: 'warning' });
            setDemandeChargee(false);
          }
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        SweetAlert.fire({ title: error, icon: 'error' });
        setDemandeChargee(false);
      });
  }

  const onSelectChange = (newSelectedRowKeys: any) => {
    const requestedIndex = Array.isArray(newSelectedRowKeys) ? newSelectedRowKeys[0] : newSelectedRowKeys;
    if (requestedIndex !== undefined && data[requestedIndex]) {
      const row = data[requestedIndex];
      setSelectedRowKeys(newSelectedRowKeys);
      form.setFieldValue('NumeroDemande', row.NumeroDemande);
      handleDemandeIjarah(); // charge automatiquement la demande
    } else {
      setSelectedRowKeys([]);
      form.setFieldValue('NumeroDemande', '');
      setDemandeChargee(false);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  function handleValidate() {
    const demandeIjarah: DemandeIjaraDto = {
      ...form.getFieldsValue(),
      DatePremEch: formatDate(form.getFieldValue('DatePremEch')),
      CODAGE: user.codage,
      UtilVal: user.coduti,
      CodeUti: user.coduti,
    } as any;

    SweetAlert.fire({
      title:
        'Voulez-vous valider la Ijarah du client : ' +
        form.getFieldValue('lib_NUMCLI') +
        ' pour la demande ' +
        form.getFieldValue('NumeroDemande') +
        ' ? ',
      showCancelButton: true,
      color: 'green',
      confirmButtonText: 'Yes',
      confirmButtonColor: 'green',
      cancelButtonColor: 'darkred',
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      icon: 'question',
    }).then((res) => {
      if (res.isConfirmed) {
        performValidate(demandeIjarah);
      }
    });
  }

  function handleReject() {
    SweetAlert.fire({
      title:
        'Voulez-vous rejeter la Ijara du client : ' +
        form.getFieldValue('lib_NUMCLI') +
        ' pour la demande ' +
        form.getFieldValue('NumeroDemande') +
        ' ? ',
      input: 'textarea',
      inputPlaceholder: 'Motif du rejet...',
      showCancelButton: true,
      color: 'red',
      confirmButtonText: 'Yes',
      confirmButtonColor: 'red',
      cancelButtonColor: 'darkgreen',
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      icon: 'question',
      preConfirm: (motif) => {
        if (!motif) {
          SweetAlert.showValidationMessage('Veuillez saisir un motif de rejet');
          return false;
        }
        return motif;
      },
    }).then((res) => {
      if (res.isConfirmed) {
        const demandeIjarah: DemandeIjaraDto = {
          ...form.getFieldsValue(),
          DatePremEch: formatDate(form.getFieldValue('DatePremEch')),
          CODAGE: user.codage,
          UtilVal: user.coduti,
          CodeUti: user.coduti,
          Observation: res.value,
        } as any;
        performValidation(demandeIjarah, '0');
      }
    });
  }

  // Appel API Validation (inchangé – fonctionne déjà)
  function performValidate(demandeIjarah: DemandeIjaraDto) {
    try {
      setLoading(true);
      setIsSubmit(true);
      let dataCrypt = Crypter.encrypt(JSON.stringify(demandeIjarah));
      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.ValidationDocumentIjarah,
        headers: {
          Authorization: authHeader(),
          'Content-Type': 'application/json',
        },
        data: dataCrypt,
      };
      axios
        .request(config)
        .then((response) => {
          setLoading(false);
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;
            if (res.StatutCode == 200) {
              handleAnnulle();
              loadFinancement();
              SweetAlert.fire({ title: res.Message, text: res.Result, icon: 'success' });
            } else {
              SweetAlert.fire({ title: res.Message, text: res.Result, icon: 'warning' });
            }
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
          SweetAlert.fire({ title: error, icon: 'error' });
        });
    } catch (error) {
      setLoading(false);
      SweetAlert.fire({ title: 'Error occurred while processing validation', icon: 'error' });
    }
  }

  // Appel API Rejet (inchangé – fonctionne déjà)
  function performValidation(demandeIjarah: DemandeIjaraDto, action: string) {
    try {
      setLoading(true);
      setIsSubmit(true);
      let dataCrypt = Crypter.encrypt(JSON.stringify(demandeIjarah));
      let actionCrypt = Crypter.encrypt(action);
      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.ValidationIjarah,
        headers: {
          Authorization: authHeader(),
          'Content-Type': 'application/json',
          Action: actionCrypt,
        },
        data: dataCrypt,
      };
      axios
        .request(config)
        .then((response) => {
          setLoading(false);
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;
            if (res.StatutCode == 200) {
              handleAnnulle();
              loadFinancement();
              SweetAlert.fire({ title: res.Message, text: res.Result, icon: 'success' });
            } else {
              SweetAlert.fire({ title: res.Message, text: res.Result, icon: 'warning' });
            }
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
          SweetAlert.fire({ title: error, icon: 'error' });
        });
    } catch (error) {
      setLoading(false);
      SweetAlert.fire({ title: 'Error occurred while processing validation', icon: 'error' });
    }
  }

  return (
    <div className="tab">
      <Typography align="center" className="formTitle">
        <b>VALIDATION DOCUMENTAIRE Ijarah</b>
      </Typography>
      <Spin spinning={loading} size="large" style={{ color: 'green' }}>
        <Form
          disabled={true}
          preserve
          autoComplete="off"
          labelAlign="left"
          form={form}
          name="dynamic_form_complex"
          style={{ minWidth: 'auto', maxWidth: 'auto' }}
        >
          <div className="bG">
            <legend>
              <Typography color={'darkgreen'}>Actions</Typography>
            </legend>
            <Form.Item shouldUpdate className="bouttong">
              <Space direction="vertical" style={{ width: '100%' }}>
                <Button
                  size="large"
                  className="bt_add"
                  disabled={!demandeChargee}
                  onClick={handleValidate}
                  type="ghost"
                  htmlType="button"
                  block
                >
                  Valider Document
                </Button>
                <Button
                  size="large"
                  className="bt_add"
                  disabled={!demandeChargee}
                  onClick={handleReject}
                  type="ghost"
                  htmlType="button"
                  block
                >
                  Rejeter
                </Button>
                <Button
                  size="large"
                  disabled={!demandeChargee}
                  onClick={handleAnnulle}
                  className="bt_add"
                  type="ghost"
                  htmlType="button"
                  block
                >
                  Annuler
                </Button>
              </Space>
            </Form.Item>
          </div>
          <div className="clientP">
            <div>
              <Tabs size="small" type="card" defaultActiveKey="1" items={items} />
            </div>
            <Box sx={{ width: '85%', mt: 0 }}>
              <Spin spinning={loading}>
                <Form disabled={false}>
                  <Table
                    size="small"
                    style={{ width: '100%' }}
                    rowSelection={{ ...rowSelection, type: 'radio' }}
                    columns={columns}
                    dataSource={data}
                    scroll={{ y: 200, x: 10 }}
                    pagination={false}
                  />
                </Form>
              </Spin>
            </Box>
          </div>
        </Form>
      </Spin>
    </div>
  );
};

export default ValidationDocumentIjarah;